import styled from '@emotion/styled';
import { rem } from 'polished';
const tableBorderColor = '#7E7E7E';

export const RCTCategoryContainer = styled.div<{ isOpen: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  border-bottom: ${props => (props.isOpen ? 'none' : `1px solid ${tableBorderColor}`)};
  margin: ${rem('20px')} auto;
  width: 100%;
  gap: 0 ${rem('20px')};
  cursor: pointer;
`;
export const RCTTableContentContainer = styled.div<{ productCount: number }>`
  display: grid;
  grid-template-columns: 1fr repeat(${props => props.productCount}, 1fr);
  font-family: VodafoneLight;
  align-items: center;
  width: 100%;

  &.last-feature-in-category {
    .feature-title {
      border-bottom: 1px solid ${tableBorderColor};
    }
    .feature-content {
      border-bottom: 1px solid ${tableBorderColor};
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
  }
`;

export const RCTFeatureTitle = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  width: 100%;
  align-items: center;
  padding: 0 ${rem('20px')};
  height: 100%;
  justify-items: start;
  border-top: 1px solid ${tableBorderColor};
  border-left: 1px solid ${tableBorderColor};
  &:last-child {
    border-right: 1px solid ${tableBorderColor};
  }
  p {
    font-size: ${rem('18px')};
    font-weight: 400;
    font-family: VodafoneRegular;
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    justify-items: center;
    padding: 0 ${rem('10px')};
    gap: 0;
    p {
      font-size: ${rem('14px')};
      white-space: normal;
      word-break: break-word;
    }
  }
`;

export const RCTFeatureContent = styled.div<{ justifyItems?: 'flex-start' | 'center' | 'flex-end' }>`
  display: grid;
  grid-template-rows: 1fr;
  width: 100%;
  height: 100%;
  justify-items: ${props => props.justifyItems || 'flex-start'};
  align-items: center;
  padding: ${rem('10px')} ${rem('20px')};
  border-top: 1px solid ${tableBorderColor};
  border-left: 1px solid ${tableBorderColor};
  &:last-child {
    border-right: 1px solid ${tableBorderColor};
  }
  p {
    font-size: ${rem('14px')};
    font-weight: 400;
    font-family: VodafoneRegular;
    margin: 0;
  }
  a {
    font-size: ${rem('14px')};
    font-weight: 400;
    font-family: VodafoneRegular;
    color: #e60000;
    text-decoration: underline;
    margin: 0;
  }

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    p {
      font-size: ${rem('11px')};
    }
    a {
      font-size: ${rem('11px')};
    }
  }
`;

export const RCTCategoryTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: ${rem('10px')};
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  padding: ${rem('16px')} ${rem('10px')};
  p {
    margin: 0;
    font-size: ${rem('18px')};
    font-weight: 700;
    font-family: VodafoneRegular;
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    p {
      font-size: ${rem('14px')};
    }
  }
`;
